import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium cursor-pointer select-none transition-all duration-200 ease-out focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 active:scale-[0.97] hover:-translate-y-0.5 hover:shadow-[0_10px_28px_rgba(0,255,136,0.12)]",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-xs hover:bg-[#18FF99] hover:text-black hover:shadow-[0_0_22px_rgba(0,255,136,0.25)] hover:scale-[1.02]",
        destructive:
          "bg-destructive text-destructive-foreground shadow-xs hover:bg-[#FF5148] hover:text-white hover:shadow-[0_0_15px_rgba(255,59,48,0.25)] hover:scale-[1.02]",
        outline:
          "border border-slate-300 dark:border-white/20 bg-white/40 dark:bg-transparent text-slate-800 dark:text-[#F8FAFC] shadow-xs hover:bg-slate-100 dark:hover:bg-white/[0.08] hover:text-slate-900 dark:hover:text-white hover:border-slate-400 dark:hover:border-white/30 hover:scale-[1.02]",
        secondary:
          "bg-slate-100 dark:bg-white/10 text-slate-900 dark:text-white shadow-xs hover:bg-slate-200 dark:hover:bg-[#35F5FF] hover:text-slate-900 dark:hover:text-black hover:shadow-[0_0_15px_rgba(0,240,255,0.2)] hover:scale-[1.02]",
        ghost:
          "bg-transparent text-slate-700 dark:text-[#CBD5E1] hover:bg-slate-100 dark:hover:bg-white/[0.06] hover:text-slate-900 dark:hover:text-white hover:scale-[1.02]",
        link:
          "text-primary underline-offset-4 hover:text-[#33FFA0] hover:underline hover:shadow-none",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
